module.exports = __webpack_public_path__ + "static/media/smartphone.dac097d6.svg";